'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { Index, Configure } from 'react-instantsearch';
import DesktopProductListingSidebarContainer from 'components/consumer/ProductListingPage/components/desktop/DesktopProductListingSidebarContainer';
import { ALGOLIA_INDEX_NAME, ALGOLIA_PRODUCT_INDEXES } from 'commons/constants';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import removeQuickshipFacet from '../../../advanced-search/helpers/removeQuickshipFacet';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import SectionButtons from './components/SectionButtons';
import WidthRangeFilter from '../WidthRangeFilter';
import ClearAllFiltersButtonComponent from '../ClearAllFiltersButton';
import ProductTypeRefinementList from './components/ProductTypeRefinementList';
import useAdvancedSearchURL from '../../hooks/useAdvancedSearchURL';
const AdvancedSearchSidebar = () => {
  const $ = _c(56);
  const {
    currentSearchSection,
    updateSearchSection,
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  const {
    queryUrlParam
  } = useAdvancedSearchURL();
  let t0;
  if ($[0] !== isReadyToShipActive) {
    t0 = isReadyToShipActive ? ["is_in_stock:true"] : [];
    $[0] = isReadyToShipActive;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const facetFilters = t0;
  let t1;
  if ($[2] !== facetFilters) {
    t1 = removeQuickshipFacet(facetFilters);
    $[2] = facetFilters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const sanitizedFacetFilters = t1;
  let t2;
  if ($[4] !== currentSearchSection) {
    t2 = ALGOLIA_PRODUCT_INDEXES.includes(currentSearchSection);
    $[4] = currentSearchSection;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const showProductFilters = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="text-base font-bold text-gray px-0 py-4">Refine by:</h2>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== updateSearchSection) {
    t4 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.PRODUCTS);
    };
    $[7] = updateSearchSection;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = currentSearchSection === ALGOLIA_INDEX_NAME.PRODUCTS;
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <SectionButtons title="Products" onClick={t4} active={t5} />;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = queryUrlParam || "";
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["*"];
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== sanitizedFacetFilters || $[14] !== t7) {
    t9 = <Configure query={t7} facets={t8} filters="" numericFilters="" facetFilters={sanitizedFacetFilters} />;
    $[13] = sanitizedFacetFilters;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== updateSearchSection) {
    t10 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS);
    };
    $[16] = updateSearchSection;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = currentSearchSection === ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS;
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <SectionButtons title="Customer Photos" onClick={t10} active={t11} />;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t9) {
    t13 = <Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}>{t9}{t12}</Index>;
    $[21] = t12;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = queryUrlParam || "";
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["*"];
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t14) {
    t16 = <Configure query={t14} facets={t15} filters="" numericFilters="" facetFilters="" />;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== updateSearchSection) {
    t17 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.REVIEWS);
    };
    $[27] = updateSearchSection;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = currentSearchSection === ALGOLIA_INDEX_NAME.REVIEWS;
  let t19;
  if ($[29] !== t17 || $[30] !== t18) {
    t19 = <SectionButtons title="Reviews" onClick={t17} active={t18} />;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t16 || $[33] !== t19) {
    t20 = <Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}>{t16}{t19}</Index>;
    $[32] = t16;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = queryUrlParam || "";
  let t22;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["is_active=1", "show_in_search=1", "fk_store_id=1"];
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t21) {
    t23 = <Configure query={t21} filters="" numericFilters={t22} />;
    $[36] = t21;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== updateSearchSection) {
    t24 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.STATIC_PAGES);
    };
    $[38] = updateSearchSection;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  const t25 = currentSearchSection === ALGOLIA_INDEX_NAME.STATIC_PAGES;
  let t26;
  if ($[40] !== t24 || $[41] !== t25) {
    t26 = <SectionButtons title="Pages" onClick={t24} active={t25} />;
    $[40] = t24;
    $[41] = t25;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== t23 || $[44] !== t26) {
    t27 = <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>{t23}{t26}</Index>;
    $[43] = t23;
    $[44] = t26;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] !== handleToggleReadyToShip || $[47] !== isReadyToShipActive || $[48] !== showProductFilters) {
    t28 = showProductFilters && <><div className="mt-4"><ClearAllFiltersButtonComponent /></div><div className="mt-4"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} /></div><div className="mt-4"><WidthRangeFilter showTitle={true} /></div><div><h3 className="text-base font-bold mb-2 mt-4">Product Type</h3><ProductTypeRefinementList /></div></>;
    $[46] = handleToggleReadyToShip;
    $[47] = isReadyToShipActive;
    $[48] = showProductFilters;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t13 || $[51] !== t20 || $[52] !== t27 || $[53] !== t28 || $[54] !== t6) {
    t29 = <DesktopProductListingSidebarContainer isOpen={true}>{t3}{t6}{t13}{t20}{t27}{t28}</DesktopProductListingSidebarContainer>;
    $[50] = t13;
    $[51] = t20;
    $[52] = t27;
    $[53] = t28;
    $[54] = t6;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  return t29;
};
export default AdvancedSearchSidebar;